import { ObjectStorage } from "../ObjectStorage";

class ClientHistoryStorage extends ObjectStorage {
    public isSecure = false;
    public key = 'clientHistory';
}

export default ClientHistoryStorage.getInstance(ClientHistoryStorage);
